import React, { useMemo } from 'react'

const DISABLED_COLOR = '#9CA3AF'

const getLighterColor = (color: string): string => {
  return `${color}20`
}

const GlCheckBoxWithText = ({
  text,
  checked,
  handleOnCheckedChange,
  color = '#252525',
  disabled = false,
}: {
  text: string
  checked: boolean
  handleOnCheckedChange: (checked: boolean) => void
  color?: string
  disabled?: boolean
}) => {
  const displayColor = useMemo(() => {
    return disabled ? DISABLED_COLOR : color
  }, [disabled, color])

  const backgroundColorContainer = useMemo(() => {
    if (!checked) return '#F7F7F7'
    return getLighterColor(displayColor)
  }, [checked, displayColor])

  return (
    <div
      className={`p-2 rounded-md transition-colors duration-200 ${
        disabled ? 'opacity-60' : ''
      }`}
      style={{
        backgroundColor: backgroundColorContainer,
      }}
    >
      <label
        className={`flex items-center gap-2 ${
          disabled ? 'cursor-not-allowed' : 'cursor-pointer'
        }`}
      >
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => {
            handleOnCheckedChange(e.target.checked)
          }}
          disabled={disabled}
          className="form-checkbox h-4 w-4 border-gray-300 rounded transition-colors duration-200 disabled:opacity-50"
          style={
            {
              accentColor: color,
              backgroundColor: checked ? displayColor : 'white',
              borderColor: disabled
                ? DISABLED_COLOR
                : checked
                ? color
                : '#D1D5DB',
              '--tw-ring-color': displayColor,
            } as React.CSSProperties
          }
        />
        <span
          className={`text-sm ${disabled ? 'text-gray-500' : 'text-gray-700'}`}
        >
          {text}
        </span>
      </label>
    </div>
  )
}

export default GlCheckBoxWithText
